import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MotifFormsModule, MotifIconModule } from '@ey-xd/ng-motif';
import { IconoirEdit } from '@ey-xd/motif-icon';
@Component({
  selector: 'app-asset-class-cell-renderer',
  standalone: true,
  imports: [MotifFormsModule, MotifIconModule],
  templateUrl: './asset-class-cell-renderer.component.html',
  styleUrl: './asset-class-cell-renderer.component.scss',
})
export class AssetClassCellRendererComponent
  implements ICellRendererAngularComp
{
  private params!: ICellRendererParams;
  public value: any;
  public isDisabled: boolean = false;
  // icons
  iconEdit = IconoirEdit;
  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = params.value;
    // Only disable if step_status is IN_PROGRESS
    this.isDisabled = params.data?.step_status === 'IN_PROGRESS';
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.value = params.value;
    this.isDisabled = params.data?.step_status === 'IN_PROGRESS';
    return true;
  }

  getValue(): string {
    return this.params.value;
  }

  enableEdit(): void {
    if (!this.isDisabled) {
      this.params.api.startEditingCell({
        rowIndex: this.params.node.rowIndex ?? 0,
        colKey: this.params.column && this.params.column.getId ? this.params.column.getId() : '',
      });
    }
  }
}
